import { connect } from '@vfde-sails/core';
import { setSelectedRouterId } from '../App/action';
import { State, mapStateToProps } from './selector';
import { mountOptionPicker, updateOptionPicker } from '../../components/optionPicker';
import { AppId } from '../../enums/elementId';
import {
    mountUnorderedVerticalList,
    updateBenefitsList,
} from '../../components/unorderedVerticalList';
import { getUpdateFlags } from './update';

const mapDispatch = {
    setSelectedRouterId,
};

function container (state: State, actions: typeof mapDispatch) {
    const routerPicker = mountOptionPicker(AppId.ROUTER_PICKER, actions.setSelectedRouterId);
    const verticalList = mountUnorderedVerticalList(AppId.BENEFIT_LIST);

    updateBenefitsList(verticalList, state.selectedId);

    return {
        getDerivedStateFromProps (newState: State, oldState: State) {
            const { routers, selectedId, availableRouterIds, disableBooking } = newState;
            const update = getUpdateFlags(newState, oldState);

            (update.routerPicker || update.disableBooking) && updateOptionPicker(
                routerPicker,
                routers,
                selectedId,
                availableRouterIds,
                disableBooking
            );

            update.verticalList && updateBenefitsList(verticalList, selectedId);
        },
    };
}

export default connect(mapStateToProps, mapDispatch)(container);
